module.exports = __webpack_public_path__ + "fonts/Inter-400-greek46.4a4b49c.woff2";